import {
    chain, curryRight, get, set, size,
} from 'lodash';

class Talent {
    constructor(data) {
        for (const [key, value] of Object.entries(data || {})) {
            set(this, key, value);
        }
    }

    static getEmailAddresses = (profile, extractValues) => {
        const mainEmailAddress = get(profile, 'contact.mainEmailAddress');
        return chain(profile)
            .get('contact.emailAddress', [])
            .concat([mainEmailAddress])
            .filter(Boolean)
            .uniqBy((e) => (e.encrypted || e.value || e))
            .map((e) => (extractValues ? get(e, 'value', e) : e))
            .value();
    };

    static getMainEmailAddress = (profile) => get(profile, 'contact.mainEmailAddress');

    static getValidEmailAddressesFromValidatedData = (profile) => chain(profile)
        .get('contact.validatedData.emailAddress', [])
        .filter(Boolean)
        .filter(this.filterAllValidatedSourcesBy)
        .value();

    static getLinkedinAddresses = (profile, extractValues) => chain(profile)
        .get('contact.webAddress', [])
        .filter({ type: 'linkedin' })
        .map('url')
        .filter(Boolean)
        .uniqBy((e) => (e.encrypted || e.value || e))
        .map((e) => (extractValues ? get(e, 'value', e) : e))
        .value();

    static getLinkedinAddressesFromValidatedData = (profile, extractValues) => chain(profile)
        .get('contact.validatedData.webAddress', [])
        .filter({ type: 'linkedin' })
        .filter(this.filterAllValidatedSourcesBy)
        .map('value')
        .filter(Boolean)
        .uniqBy((e) => (e.encrypted || e.value || e))
        .map((e) => (extractValues ? get(e, 'value', e) : e))
        .value();

    static filterAllValidatedSourcesBy = (source) => {
        const {
            unique,
            sentToValidation,
            validated,
            irrelevant,
            preferred,
        } = source;

        const isValid = unique && sentToValidation && validated && !irrelevant;
        return isValid || preferred;
    };

    static getValidatedPreferredLinkedinAddress = (profile) => (chain(profile).get('contact.validatedData.webAddress', []).size().value()
        ? chain(profile)
            .get('contact.validatedData.webAddress')
            .filter(Boolean)
            .filter({ type: 'linkedin' })
            .filter(this.filterAllValidatedSourcesBy)
            .sortBy('preferred', 'desc')
            .map('value')
            .value()[0]
        : this.getLinkedinAddresses(profile, true)[0]);

    static getEmailAddressDisplayValues = curryRight(Talent.getEmailAddresses)(true);

    static hasEmailAddresses = (profile) => !!size(Talent.getEmailAddresses(profile));

    static hasLinkedinAddresses = (profile) => !!size(Talent.getLinkedinAddresses(profile));
}

export default Talent;
